module.exports = __webpack_public_path__ + "img/spider-circles.d18e324d.png";